import { getAggregateError, } from "@bracket/catch";
import { getTokens, } from "@bracket/chainography";
import { contract, multiCaller, } from "@bracket/chainography/contracts";
import { wagmiConfig as config, } from "@wagmiconfig";
import { DateTime, } from "luxon";	
import { gql, } from "./helpers";



/**
 * Fetches exchange rates for all platform supply tokens
 * 
 * @returns {Promise<Record<string, bigint>>} A collection of token rates indexed by token symbol
 * @example
 * // Returns something like { "ETH": 1000000000000000000n, "USDC": 1000000n, ... }
 * const tokenRates = await getRates();
 */
export const getRates = async () => {
	const tokens = getTokens({ platform_supply: true, });
	const [ rates, errors, ] = await multiCaller<Array<bigint>>(config, tokens.map(token => {
		const shim  = contract("BracketOracle", "getRate", token.address);
		return shim;
	}));
	if(errors) {
		throw getAggregateError(errors, "Pricing:Resolvers::getRates failed to get rates");
	}
	// const rates = await Promise.all(tokens.map(token => getRate({ token, config, })));
	const collection = tokens.reduce((acc, token, i) 	=> Object.assign(acc, {[token.symbol]: rates[i], }), {});
	return collection;
}



/**
 * Calculates the Annual Percentage Yield (APY) for block rewards
 * 
 * This function computes the APY by comparing BRKT conversion rates from today
 * and one week ago, then annualizing the weekly return rate.
 * 
 * @returns {Promise<number>} The calculated APY as a decimal (e.g., 0.05 for 5% APY)
 * @example
 * // Returns something like 0.12 for a 12% APY
 * const apy = await getBlockRewardsAPY();
 */
export const getBlockRewardsAPY = async ():Promise<number> => {
	const now = DateTime.now().toUTC().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
	const today = now.toISO();
	const week_ago = now.minus({ days: 7, }).toISO();
	const { brkt_price_period, } = await gql("BRKT_PRICE_PERIOD", week_ago, today);
	const [ brkt_now, brkt_week_ago, ] = brkt_price_period;
	const { conv_rate:conv_rate_now, } = brkt_now;
	const { conv_rate:conv_rate_then, } = brkt_week_ago;
	const result = ((1+Number(conv_rate_now)-Number(conv_rate_then)) ** 52)-1;
	return result;
}
